<template>
    <section class="gintonic">
        <div class="container">
            <div class="paragraph" data-aos="fade-up">
                <h2>簡単！おいしい<br class="hidePc">ジントニックの作り方</h2>
            </div>
            <div class="contents">
                <ul class="list" data-aos="fade-up">
                    <li >
                        <Icon1 class="icon" />
                        <span class="text">ボンベイ・サファイア30ml</span>
                    </li>
                    <Plus class="include"  data-aos-delay="400"/>
                    <li >
                        <Icon2 class="icon" />
                        <span class="text">トニックウォーター120ml</span>
                    </li>
                    <Plus class="include"  data-aos-delay="400"/>
                    <li >
                        <Icon3 class="icon" />
                        <span class="text">カットライム1/8個</span>
                    </li>
                </ul>
                <div class="img-box" data-aos="fade-left" data-aos-delay="400">
                    <img src="@/assets/img/jintonic.png" alt="jintonic">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Icon1 from '@/assets/img/jin-01.svg?inline'
import Icon2 from '@/assets/img/jin-02.svg?inline'
import Icon3 from '@/assets/img/jin-03.svg?inline'
import Plus from '@/assets/img/icon_plus.svg?inline'

export default {
    components:{
        Icon1,Icon2,Icon3,Plus
    }
    
}
</script>

<style lang="scss" scoped>
.gintonic{
    background-image: url('~@/assets/img/wood_bg.jpg');
    background-size: cover;
    background-position: center;
    position: relative;
    .container{
        height: auto;
        flex-flow: column;
        align-items: flex-start;
        justify-content: flex-start;
        color: #fff;
        @media #{$maxL}{
            height: auto;
        }
            h2{
                text-align: center;
                width: 100%;
                @media #{$maxXL}{
                    font-size: 4.4vw;
                }
                @media #{$maxL}{
                    font-size: 1.964em;
                    text-align: left;
                }
            }
            .contents{
                width: 100%;
                height: 600px;
                @extend %flex;
                justify-content: center;
                align-items: flex-start;
                flex-flow: row nowrap;
                position: relative;
                margin-top: 72px;
                @media #{$maxL} {
                    flex-flow: column;
                    align-items: center;
                    height: auto;
                }
                @media #{$maxS}{
                    margin-top: 42px;
                }
                .img-box{
                    @extend %flex;
                    position: relative;
                    height: 100%;
                    
                    @media #{$maxL} {
                        margin-top: 72px;
                        height: auto;
                        width: 40%;
                    }
                    @media #{$maxS}{
                        margin-top: 42px;
                    }
                    img{
                        height: 100%;
                        width: auto;
                        @media #{$maxL} {
                            width: 100%;
                            height: auto;
                        }
                        @media #{$IE}{
                            width: auto;
                            height: auto;
                            max-width: 350px;
                            max-height: 600px;
                            @media #{$maxL} {
                                max-width: 291px;
                                max-height: 500px;
                            }
                        }
                    }
                }
                ul.list{
                    $iconSize: 8em;
                    @extend %flex;
                    flex-flow: column;
                    align-items: center;
                    justify-content: center;
                    width: 60%;
                    position: relative;
                    @media #{$maxL} {
                        width: 100%;
                    }
                    li{ 
                        @extend %flex;
                        width: 100%;
                        flex-flow: row nowrap;
                        align-items: center;
                        justify-content: center;
                        .icon{
                            height: $iconSize;
                            width: $iconSize;
                            .jin01-1{fill:none;}.jin01-2{fill:#2ca6e0;}.jin01-3{fill:#fff;opacity:0.5;}
                            fill: #2ca6e0;
                            margin-right: 3em;
                            @media #{$maxS}{
                                width: 54px;
                                height: 54px;
                                margin-right: 5px;
                                margin-left: -5%;
                            }
                        }
                        .text{
                            font-size: 2.3em;
                            width: calc(100% - 4.6em);
                            line-height: 1.75em;
                            @media #{$maxS}{
                                font-size: 1.414em;
                            }
                        }
                    }
                    .include{
                        height: 4.6em;
                        width: 4.6em;
                        margin: 1em 0;
                        margin-right: 6em;
                        @media #{$maxL} {
                            margin-right: 0;
                        }
                        @media #{$maxS}{
                            height: 1.4em;
                            width: 1.4em;
                        }
                    }
                }
            }
    }
}
</style>